import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Tab } from "@mui/material";
import GetSiteRec from "../../../components/api/GetSiteRec";
import { useState, useEffect } from "react";
import DatePicker from '../../../components/datepicker/DatePicker';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSite } from "../../../components/siteselector/SiteContext";
import DataUnavailable from "../../../components/data/DataUnavailable";
import LoginCookieAuth from "../../../components/api/LoginCookieAuth";
import Cookies from "js-cookie";
import GetParam from "../../../components/api/GetParam";
import { TabContext, TabPanel } from "@mui/lab";
import TabList from '@mui/lab/TabList';
import GetUser from "../../../components/api/GetUser";
import { JaarVergelijking } from "../../../components/charts2/yearcomparison";
import DayProfile from "../../../components/charts2/dayprofile";
import OpeningTimesChart from "../../../components/charts2/openingtimes";
import ValidatePageAccess from "../../../components/api/ValidatePageAccess";

const ProfileScene = () => {
  const { selectedSite } = useSite();
  const navigate = useNavigate();
  const { siteId } = useParams();
  const location = useLocation()
  const [pageAcces, SetPageAcces] = useState(false)
  const dateRange = GetParam('dateRange', location)
  const [selectedView, SetSelectedView] = useState('1')
  const [selectedYear, setSelectedYear] = useState('2023')
  const [selectedDayProfileMeter, setSelectedDayProfileMeter] = useState([])
  // New settings states
  const [siteObject, setSiteObject] = useState()
  const [yearcomparisonTypeList , setYearcomparisonTypeList] = useState([])
  const [consumptionratioTypeList, setConsumptionratioTypeList] = useState([])
  const [consumptionratioPointList, setConsumptionratioPointList] = useState([])
  const [tabWhiteList2, SetTabWhiteList2] = useState([])
  const [userTabWhitelist, setUserTabWhitelist] = useState([])

  const handleTabChange = (event, newValue) => {
    SetSelectedView(newValue);
  };

  const HandleChangeYear = (e) => {
    setSelectedYear(e.target.value)
  }

  const HandleDayProfileMeterChange = (e) => {
    setSelectedDayProfileMeter(e.target.value)
  }

  // Check for acces to page
  useEffect(() => {
    const GetPageAccess = async () => {
      let response = await ValidatePageAccess(siteId, 'ems/profile')
      SetPageAcces(response)
      if(!response) navigate(`/projects/${siteId}/buildingoverview`)
    } 
    
    GetPageAccess()
  }, [siteId, navigate])

  // Fetching project data for building charts and views
  useEffect(() => {
    LoginCookieAuth(Cookies.get('skyarc-auth-8080')).then(async (authResponse) => {
      if(authResponse){
        // Fetch site data & set site data object
        GetUser().then((response) => {
          setUserTabWhitelist(response['data']['rows'][0]['infSiteTabs'])
        })
        GetSiteRec(siteId).then((response) => {
          setSiteObject(response['data']['rows'][0])
          // Check if project has settings tag and settings tag is not empty
          if(response['data']['rows'][0]['settings'] !== undefined && response['data']['rows'][0]['settings'].length !== 0) {
            // Find setting key yearcomparison and set typelist
            if(response['data']['rows'][0]['settings'].find((setting) => setting['infModuleSettingsKey'] === 'ems/profile/yearcomparison') !== undefined) {
              setYearcomparisonTypeList(response['data']['rows'][0]['settings'].find((setting) => setting['infModuleSettingsKey'] === 'ems/profile/yearcomparison')['infEnergyPointTypes'])
            }
            // Find setting key dayprofile and set index 0 meter
            if(response['data']['rows'][0]['settings'].find((setting) => setting['infModuleSettingsKey'] === 'ems/profile/dayprofile') !== undefined) {
              setSelectedDayProfileMeter(response['data']['rows'][0]['settings'].find((setting) => setting['infModuleSettingsKey'] === 'ems/profile/dayprofile')['infEnergyPoints'][0]['id']['val'])
            }
            // Find setting key consumptionratio and set pointlist
            if(response['data']['rows'][0]['settings'].find((setting) => setting['infModuleSettingsKey'] === 'ems/profile/consumptionratio') !== undefined) {
              setConsumptionratioTypeList(response['data']['rows'][0]['settings'].find((setting) => setting['infModuleSettingsKey'] === 'ems/profile/consumptionratio')['infEnergyPointTypes'])
              setConsumptionratioPointList(response['data']['rows'][0]['settings'].find((setting) => setting['infModuleSettingsKey'] === 'ems/profile/consumptionratio')['infEnergyPoints'])
            }
            // Create array with all setting keys
            let tabWhiteList = [];
            response['data']['rows'][0]['settings'].forEach((setting) => {
              tabWhiteList.push(setting.infModuleSettingsKey);
            });
            SetTabWhiteList2(tabWhiteList);
          } else {
            setYearcomparisonTypeList([])
            SetTabWhiteList2([])
          }
        })
      } 
    })
  },[siteId, selectedSite])

  // Check wich tabs the project has acces too
  useEffect(() => {
    if(siteObject !== undefined && siteObject['settings'] !== undefined) {
      if(siteObject['settings'].some((setting) => setting['infModuleSettingsKey'].includes('ems/profile/yearcomparison')) && userTabWhitelist.includes('jaarvergelijking')) return SetSelectedView('1')
      else if(siteObject['settings'].some((setting) => setting['infModuleSettingsKey'].includes('ems/profile/dayprofile')) && userTabWhitelist.includes('dagprofiel')) return SetSelectedView('2')
      else if(siteObject['settings'].some((setting) => setting['infModuleSettingsKey'].includes('ems/profile/consumptionratio')) && userTabWhitelist.includes('jaarprofiel')) return SetSelectedView('3') 
    }
  }, [siteObject, userTabWhitelist])

  return (
    <>  
      {
        pageAcces ? (
          <Box m="18px" maxWidth="100%">
            {/* VIEW SWITCHER */}
            <Box sx={{ width: '100%' }}>
              {
                userTabWhitelist.length !== 0 && tabWhiteList2.length !== 0 ? (
                  <TabContext value={selectedView}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop:'-18px' }}>
                    <TabList onChange={handleTabChange}>
                      {userTabWhitelist.includes('jaarvergelijking') && tabWhiteList2.some(item => item.includes('ems/profile/yearcomparison'))  ? (<Tab sx={{ fontWeight: 'bold', textTransform: 'none' }} label="Jaarvergelijking" value="1"/>) : (null)}
                      {userTabWhitelist.includes('dagprofiel') && tabWhiteList2.some(item => item.includes('ems/profile/dayprofile')) ? (<Tab sx={{ fontWeight: 'bold', textTransform: 'none' }} label="Dag profiel" value="2"/>) : (null)}
                      {userTabWhitelist.includes('jaarprofiel') && tabWhiteList2.some(item => item.includes('ems/profile/consumptionratio')) ? (<Tab sx={{ fontWeight: 'bold', textTransform: 'none' }} label="Verhouding verbruik" value="3"/>) : (null)}
                    </TabList>
                  </Box>
                  {/* TAB Jaar vergelijking */}
                  <TabPanel value="1" sx={{ padding: '0px', marginTop: '18px' }}>
                    {
                      yearcomparisonTypeList.length === 0 ? (<DataUnavailable />) : yearcomparisonTypeList.map(element => (<JaarVergelijking key={element} pointList={siteObject['settings'].find((setting) => setting['infModuleSettingsKey'] === "ems/profile/yearcomparison") !== undefined ? (siteObject['settings'].find((setting) => setting['infModuleSettingsKey'] === "ems/profile/yearcomparison")['infEnergyPoints'].filter(point => point[element] != null)) : ([])} />))
                    }
                  </TabPanel>
                  <TabPanel value="2" sx={{ padding: '0px', marginTop: '18px' }}>
                    <FormControl sx={{ width: '150px', textAlign: 'center', marginBottom:'18px' }}>
                      <InputLabel shrink={true} sx={{color:'black'}} id="yearpicker-label">Selecteer jaar</InputLabel>
                      <Select
                        id="yearpicker"
                        labelId="yearpicker-label"
                        label="Selecteer jaar"
                        value={selectedYear}
                        onChange={(e) => HandleChangeYear(e)}
                        sx={{ width: '100%', height: '30px', color: 'gray' }}
                        inputProps={{ style: { textAlign: 'center' } }}
                      >
                        <MenuItem value={'2024'}>2024</MenuItem>
                        <MenuItem value={'2023'}>2023</MenuItem>
                        <MenuItem value={'2022'}>2022</MenuItem>
                        <MenuItem value={'2021'}>2021</MenuItem>
                        <MenuItem value={'2020'}>2020</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: '250px', textAlign: 'center', marginLeft:'8px' }}>
                      <InputLabel shrink={true} sx={{color:'black'}} id="dayprofile-meter-selector-label">Selecteer meter</InputLabel>
                      <Select
                        id="day-profile-meter-selector"
                        labelId="dayprofile-meter-selector-label"
                        label="Selecteer meter"
                        value={selectedDayProfileMeter}
                        onChange={(e) => HandleDayProfileMeterChange(e)}
                        sx={{ width: '100%', height: '30px', color: 'gray' }}
                        inputProps={{ style: { textAlign: 'center' } }}
                      >
                        {
                          siteObject !== undefined ? (
                            siteObject['settings'].find((setting) => setting['infModuleSettingsKey'] === "ems/profile/dayprofile") !== undefined ? (
                              siteObject['settings'].find((setting) => setting['infModuleSettingsKey'] === "ems/profile/dayprofile")['infEnergyPoints'].map((point) => {
                                return(<MenuItem value={point['id']['val']} key={point['id']['val']}>{point['id']['dis']}</MenuItem>)
                              })
                            ) : (
                              console.log('geen dayprofile settings')
                            )
                          ) : (
                            console.log('siteobject nog niet geset')
                          )
                        }
                      </Select>
                    </FormControl>
                    <Grid container gap={2} wrap='nowrap' sx={{marginBottom:'15px'}}>
                      {/* Lente */}
                      <Grid item xl={6} xs={6} sx={{width:'400px', height:'500px', backgroundColor:'#f2f0f0', boxShadow: 3}}>
                        <DayProfile dateRange={`${selectedYear}-03-01..${selectedYear}-05-31`} titel='Lente' meterId={selectedDayProfileMeter}/>
                      </Grid>
                      {/* Zomer */}
                      <Grid item xl={6} xs={6} sx={{width:'400px', height:'500px', backgroundColor:'#f2f0f0', boxShadow: 3}}>
                        <DayProfile dateRange={`${selectedYear}-06-01..${selectedYear}-08-31`} titel='Zomer' meterId={selectedDayProfileMeter}/>
                      </Grid>
                    </Grid>
                    <Grid container gap={2} wrap='nowrap'>
                      {/* Herfst */}
                      <Grid item xl={6} xs={6} sx={{width:'400px', height:'500px', backgroundColor:'#f2f0f0', boxShadow: 3}}>
                        <DayProfile dateRange={`${selectedYear}-09-01..${selectedYear}-11-30`} titel='Herfst' meterId={selectedDayProfileMeter}/>
                      </Grid>
                      {/* Winter */}
                      <Grid item xl={6} xs={6} sx={{width:'400px', height:'500px', backgroundColor:'#f2f0f0', boxShadow: 3}}>
                       <DayProfile dateRange={`${selectedYear}-12-01..(${parseInt(selectedYear) + 1}-03-01 - 1day)`} titel='Winter' meterId={selectedDayProfileMeter}/>
                      </Grid>
                    </Grid>
                  </TabPanel>
                  <TabPanel value="3" sx={{ padding: '0px', marginTop: '18px' }}>
                    <Box sx={{ marginBottom: '18px', display: 'flex' }}>
                      <DatePicker />
                    </Box>
                      {
                        consumptionratioTypeList.length === 0 ? (<DataUnavailable />) : (
                          consumptionratioTypeList.map((element) => {
                            return <OpeningTimesChart key={element} dateRange={dateRange} pointList={consumptionratioPointList.filter(point => point[element] != null)}/>
                          })
                        )
                      }
                  </TabPanel>
                </TabContext>
                ) : (
                  <Box sx={{width:'100%', height:'850px', display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <DataUnavailable message="Geen modules beschikbaar"/> 
                  </Box>
                )
              }
            </Box>
          </Box>
        ) : (
          null
        )
      }
    </>
  );
};

export default ProfileScene;